import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cx } from './cx';
import { focusRing } from './focusRing';

export interface PageHeaderBack {
  /** Visible, translated label, e.g. "Back to settings". */
  label: string;
  to?: string;
  onClick?: () => void;
}

export interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  back?: PageHeaderBack;
  /** Right-aligned actions (icon buttons, a primary button). */
  actions?: React.ReactNode;
  className?: string;
}

const backClass = cx('inline-flex items-center gap-1.5 self-start rounded-control font-ui text-small font-medium text-link hover:text-primary', focusRing);

/** The one page title: h1 at title-lg, optional back link and actions. */
export default function PageHeader({ title, subtitle, back, actions, className }: PageHeaderProps) {
  return (
    <header className={cx('flex min-w-0 flex-col gap-2', className)}>
      {back ? (
        back.to ? (
          <Link to={back.to} className={backClass}>
            <ArrowLeft aria-hidden className="size-4" />
            {back.label}
          </Link>
        ) : (
          <button type="button" onClick={back.onClick} className={backClass}>
            <ArrowLeft aria-hidden className="size-4" />
            {back.label}
          </button>
        )
      ) : null}
      <div className="flex min-w-0 items-start justify-between gap-3">
        <div className="flex min-w-0 flex-col gap-1">
          <h1 className="m-0 font-display k-page-title text-[1.375rem]/[1.875rem] text-primary @bp-sm:text-title-lg">{title}</h1>
          {subtitle ? <p className="m-0 font-ui text-small text-secondary">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    </header>
  );
}
